import { StoreShopifyInfo, StoreShopifySyncInfo } from "../types";
import { fetchWithTimeout } from "./http";

const urlStore = process.env.REACT_APP_API_NODE_URL + "stores";
const SHOPIFY_TIMEOUT_MS = 30000;

/** Store URL, order webhook and the sales channels: everything on mapper.stores. */
export const editStoreShopify = async (storeShopifyInfo: StoreShopifyInfo) => {
    const body = JSON.stringify(storeShopifyInfo);

    const response = await fetch(`${urlStore}/update/shopify/${storeShopifyInfo.id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body,
        credentials: 'include'
    });

    if (!response.ok) {
        throw new Error(`Failed to edit store sync: ${response.statusText}`);
    }
    const data = await response.json();
    if (!data) {
        console.error('Received empty or invalid JSON response from the server.');
        throw new Error('Invalid server response.');
    }
    return data;
}

/** Sync app credentials, stored on auth.storeshopifyapps under the Sync role. */
export const editShopifySyncInfo = async (updatedStore: StoreShopifySyncInfo) => {
    const body = JSON.stringify(updatedStore);
    const response = await fetch(`${urlStore}/update/shopifySync/${updatedStore.id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body,
        credentials: 'include'
    });
    if (!response.ok) {
        throw new Error(`Failed to edit store information: ${response.statusText}`);
    }
    const data = await response.json();
    if (!data) {
        console.error('Received empty or invalid JSON response from the server.');
        throw new Error('Invalid server response.');
    }
    return data;
}

/** Hydrogen app credentials, stored on auth.storeshopifyapps under the Hydrogen role. */
export const editShopifyHydrogenInfo = async (updatedStore: StoreShopifySyncInfo) => {
    const body = JSON.stringify(updatedStore);
    const response = await fetch(`${urlStore}/update/shopifyHydrogen/${updatedStore.id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body,
        credentials: 'include'
    });
    if (!response.ok) {
        throw new Error(`Failed to edit store information: ${response.statusText}`);
    }
    const data = await response.json();
    if (!data) {
        console.error('Received empty or invalid JSON response from the server.');
        throw new Error('Invalid server response.');
    }
    return data;
}

export type SalesChannel = {
    publicationId: string;
    name: string | null;
};

export const getSalesChannels = async (storeId: number): Promise<SalesChannel[]> => {
    const response = await fetchWithTimeout(
        `${urlStore}/${storeId}/sales-channels`,
        { method: 'GET', credentials: 'include', cache: 'no-store' },
        SHOPIFY_TIMEOUT_MS
    );

    if (!response.ok) {
        throw new Error(`Failed to read the sales channels: ${response.statusText}`);
    }

    const data = await response.json();
    if (!Array.isArray(data)) {
        console.error('Received empty or invalid JSON response from the server.');
        throw new Error('Invalid server response.');
    }

    return data as SalesChannel[];
};
